export const HISTORY_INITIAL_STATE = "HISTORY_INITIAL_STATE";